import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e9314f2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "MapGeocoder" }
const _hoisted_2 = { class: "select-none text-sm text-gray-400" }
const _hoisted_3 = {
  key: 0,
  class: "flex justify-center items-center text-center mt-3"
}
const _hoisted_4 = {
  key: 1,
  class: "text-sm text-red-400"
}
const _hoisted_5 = {
  key: 1,
  class: "MapGeocoder__list flex flex-col mt-2"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "text-sm font-semibold" }
const _hoisted_8 = { class: "text-xs text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_loader = _resolveComponent("loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      (Boolean(_ctx.cityName))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode("Геокодирование по адресу (" + _toDisplayString(_ctx.cityName) + ")", 1)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode("Геокодирование по адресу")
          ], 64))
    ]),
    _createVNode(_component_the_input, {
      class: "w-full mt-1",
      placeholder: "Адрес",
      value: _ctx.state.geocode_query,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.geocode_query) = $event)),
      onInput: _ctx.geocode
    }, null, 8, ["value", "onInput"]),
    (_ctx.state.is_loading || _ctx.state.is_failed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createBlock(_component_loader, {
                key: 0,
                class: "primary"
              }))
            : (_ctx.state.is_failed)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Ошибка при геокодировании"))
              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.state.is_loading && !_ctx.state.is_failed && _ctx.state.results.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.results, (result, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "MapGeocoder__item",
              key: `geocode-result-${i}`,
              onClick: ($event: any) => (_ctx.emitSelect(result))
            }, [
              _createElementVNode("p", _hoisted_7, _toDisplayString(result.name), 1),
              _createElementVNode("p", _hoisted_8, _toDisplayString(result.description), 1)
            ], 8, _hoisted_6))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}